// Kiosk ("Vendor Market display") state for this device.
const KEY = "awg_kiosk";
export const isKiosk = () => { try { return localStorage.getItem(KEY) === "1"; } catch { return false; } };
export const setKiosk = (on) => { try { on ? localStorage.setItem(KEY, "1") : localStorage.removeItem(KEY); } catch {} window.dispatchEvent(new Event("awg-kiosk")); };
